import { useCallback } from "react";
import useSWRMutation from "swr/mutation";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { Settings } from "./types/settings";

const deckSettingsUrl = "/modules/deck_designer/settings";

export const useDeckSettingsApi = () => {
  const api = useApi();

  // Per calculation: the lists come filtered by visibility (plus whatever the calculation already
  // uses) and sorted by order. No key until the calculation is known.
  const getDeckSettings = useCallback(
    (calculationId: string | undefined, signal: AbortSignal) => {
      const url = calculationId ? `${deckSettingsUrl}?calculation_id=${encodeURIComponent(calculationId)}` : null;
      return useSWRMutation<Settings, CustomError, string | null>(url, (requestUrl: string) =>
        api.get<Settings>({ url: requestUrl, signal }),
      );
    },
    [api],
  );

  return {
    getDeckSettings,
  };
};

export default useDeckSettingsApi;
